import { JSONCasing } from "json-casing";
import _ from "lodash";
import "whatwg-fetch"; // Polyfill for Fetch for IE.
import { EnviroConfig } from "../../EnviroConfig";

export enum ArrowType {
  One,
  Two,
}

export interface IImageDetails {
  displayName?: string;
  name: string;
  path: string;
  type: string;
}

export interface IBannerSlide {
  alt?: string;
  caption?: string;
  cropped?: IImageDetails;
  id: string;
  imageAction?: "_self" | "_blank";
  isLoaded?: boolean;
  original?: IImageDetails;
  title?: string;
  transform?: any;
  url?: string;
}

export interface ISettings {
  arrowType: ArrowType;
  arrows: boolean;
  backgroundColor: string;
  backgroundHoverColor: string;
  caption: string;
  color: string;
  customCaption: boolean;
  dimensions: {
    height: number;
    width: number;
  };
  dots: boolean;
  fade: boolean;
  hoverColor: string;
  lazyLoad: boolean;
  randomStartImage: boolean;
  slideshowMode: boolean;
  speed: number;
}

const enviroConfig = new EnviroConfig();

const bannerServiceURL = _.trimEnd(enviroConfig.bannerServiceURL, "\/\\");

const getNoCacheUrl = (url) => `${url}?_ts=${new Date().getTime()}`;

export function uploadFile(portletInstanceId: string, file: Blob | File) {
  const data = new FormData();
  data.append("file", file);
  const headers = new Headers();
  headers.append("Accept", "application/json, text/javascript, */*; q=0.01");
  return fetch(getNoCacheUrl(`${bannerServiceURL}/${portletInstanceId}`), {
    body: data,
    cache: "no-store",
    credentials: "same-origin",
    headers,
    method: "POST",
  });
};

export function loadBanner(portletInstanceId: string) {
  const headers = new Headers();
  headers.append("Accept", "application/json, text/javascript, */*; q=0.01");
  return fetch(getNoCacheUrl(`${bannerServiceURL}/${portletInstanceId}`), {
    cache: "no-store",
    credentials: "same-origin",
    headers,
    method: "GET",
  })
    .then((res: any) => {
      let result = res;
      if (res.d) { result = res.d; } // .NET service response encloses payload in a 'd' property.
      return result.json();
    })
    .then((result: any) => JSONCasing.toCamel(result));
};

export function saveBanner(portletInstanceId: string, details: { settings: ISettings, slides: IBannerSlide[] }) {
  const headers = new Headers();
  headers.append("Accept", "application/json, text/javascript, */*; q=0.01");
  headers.append("Content-Type", "application/json; charset=UTF-8");
  return fetch(getNoCacheUrl(`${bannerServiceURL}/${portletInstanceId}`), {
    body: JSON.stringify(JSONCasing.toPascal(details)),
    cache: "no-store",
    credentials: "same-origin",
    headers,
    method: "PUT",
  });
};
